import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { announceLicenseReadOnly } from "../../lib/licenseReadOnly";

/** Екран, затворен в режим „само преглед" (lib/licenseReadOnly.ts): модалът
 * „Само преглед" и обратно към `to` — и когато режимът започне, докато човекът
 * е вътре. */
export default function LicenseReadOnlyRedirect({ to }: { to: string }) {
  useEffect(() => {
    announceLicenseReadOnly();
  }, []);
  return <Navigate to={to} replace />;
}
